import type { EasingType, IImage, ILine, IRichText, ISymbol } from '@visactor/vrender-core';
import type { ArcSegment, Segment } from '../../segment';
import type { Tag } from '../../tag';
import { getSegmentLineGraphics, graphicFadeIn } from './common';
import { commitUpdateAnimationTarget } from '../../animation/static-truth';

export function pointCallIn(
  itemLine: Segment | ArcSegment,
  decorativeLine: ILine,
  item: Tag | IRichText | ISymbol | IImage,
  duration: number,
  delay: number,
  easing: EasingType
) {
  const startSymbolDuration = 0.1 * duration;
  const lineDuration = 0.65 * duration;
  const decorativeDuration = 0.05 * duration;
  const endSymbolDuration = 0.1 * duration;
  const labelDuration = 0.1 * duration;

  // start symbol
  graphicFadeIn(itemLine.startSymbol, delay, startSymbolDuration, easing);

  // line
  const lines = getSegmentLineGraphics(itemLine);
  lines.forEach(line => commitUpdateAnimationTarget(line, { clipRange: 1 }, { clipRange: 0 }));
  lines.forEach((l, index) => {
    const stepDuration = lineDuration / lines.length;
    l.animate()
      .wait(delay + startSymbolDuration + index * stepDuration)
      .to({ clipRange: 1 }, stepDuration, easing);
  });

  graphicFadeIn(decorativeLine, delay + startSymbolDuration + lineDuration, decorativeDuration, easing);

  // end symbol
  graphicFadeIn(
    itemLine.endSymbol,
    delay + startSymbolDuration + lineDuration + decorativeDuration,
    endSymbolDuration,
    easing
  );

  if (item.getTextShape?.()) {
    // text
    graphicFadeIn(
      item.getTextShape(),
      delay + startSymbolDuration + lineDuration + decorativeDuration + endSymbolDuration,
      labelDuration,
      easing
    );

    // text background
    graphicFadeIn(
      item.getBgRect(),
      delay + startSymbolDuration + lineDuration + endSymbolDuration,
      labelDuration,
      easing
    );
  } else {
    graphicFadeIn(item, delay + startSymbolDuration + lineDuration + endSymbolDuration, labelDuration, easing);
  }
}
